import React from "react";

const TweetPromote = ({
    isSoundOn,
    volume,
    setVolume,
    streamerUsername,
    winnerUsername
}) => {

    const handleTweetPromote = () => {
        const tweetText =
`🎉 Huge congrats to @${winnerUsername} for winning our giveaway on @${streamerUsername}'s Twitch stream! 🚀
Congrats https://twitch.tv/${winnerUsername} 🎉
Missed out? Follow for more chances to win and join the next stream: https://twitch.tv/${streamerUsername}
#Giveaway #Twitch #Streamer #Winners #iplaymore #thundergiveaway`;
        const tweetUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetText)}`;
        window.open(tweetUrl, "_blank");
    };

    const tweetClickSound = () => {
        const audio_tweet_click = new Audio('sound/button_sound/Tweet_Prom_BTN.ogg');
        audio_tweet_click.volume = volume / 100;
        audio_tweet_click.play();
    }

    return (
        <div>
            <button
                className="common-but tweet-promote-but"
                onClick={() => {
                    handleTweetPromote();
                    isSoundOn && tweetClickSound();
                }}
            >
                Tweet & promote
            </button>
        </div>
    );
};

export default TweetPromote;
